import React, { useState } from "react";
import axios from "axios";
import { ShieldAlert, LogOut, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Persistent banner shown while a super-admin is impersonating an admin of a
 * specific center. Lets them end the session and return to their super-admin
 * view in one click.
 */
export default function ImpersonationBanner({ user }) {
  const [stopping, setStopping] = useState(false);
  if (!user?.impersonator_email) return null;

  const handleStop = async () => {
    if (stopping) return;
    setStopping(true);
    try {
      const { data } = await axios.post(`${API}/auth/stop-impersonation`);
      localStorage.setItem("auth_token", data.token);
      localStorage.removeItem("auth_user");
      toast.success(data.message || "Session super-admin restaurée");
      window.location.href = "/centres";
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Impossible de terminer la session");
      setStopping(false);
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[80] bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm min-w-0">
          <ShieldAlert className="h-4 w-4 flex-shrink-0" />
          <span className="font-medium">Mode impersonation</span>
          <span className="text-amber-50/90 truncate">
            — vous consultez ce centre en tant qu'administrateur. Toute action sera tracée au nom de <strong>{user.impersonator_name || user.impersonator_email}</strong>.
          </span>
        </div>
        <button
          data-testid="stop-impersonation-button"
          onClick={handleStop}
          disabled={stopping}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 text-xs font-semibold backdrop-blur transition-colors disabled:opacity-60 disabled:cursor-wait"
        >
          {stopping
            ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : <LogOut className="h-3.5 w-3.5" />}
          Retour super-admin
        </button>
      </div>
    </div>
  );
}
